export const EMPTY_EMPLOYEE_UNAVAILABILITIES = {
  list: [],
  isLoaded: false,
  isLoading: false,
  isDataOutdated: false,
  invalidationVersion: 0,
  requestId: null,
  error: null
};

export function employeeUnavailabilityKey(enterpriseId, employeeId) {
  return enterpriseId && employeeId ? `${enterpriseId}:${employeeId}` : null;
}

export const employeeUnavailabilityHandlers = {
  "onboarding/EMPLOYEE_UNAVAILABILITIES_REQUEST": (state, payload) => {
    const { key, enterpriseId, employeeId, requestId } = payload;
    const entry =
      state.employeeUnavailabilities[key] || EMPTY_EMPLOYEE_UNAVAILABILITIES;
    return {
      ...state,
      employeeUnavailabilities: {
        ...state.employeeUnavailabilities,
        [key]: {
          ...entry,
          enterpriseId,
          employeeId,
          requestId,
          isLoading: true,
          error: null
        }
      }
    };
  },
  "onboarding/EMPLOYEE_UNAVAILABILITIES_RECEIVE": (state, payload) => {
    const { key, requestId, version, list, error } = payload;
    const entry = state.employeeUnavailabilities[key];
    // Ignore responses from requests started before RESET_ALL or a newer request.
    if (!entry || entry.requestId !== requestId) return state;
    const invalidated = entry.invalidationVersion !== version;
    return {
      ...state,
      employeeUnavailabilities: {
        ...state.employeeUnavailabilities,
        [key]: {
          ...entry,
          list: error || invalidated ? entry.list : list,
          isLoaded: entry.isLoaded || (!error && !invalidated),
          isLoading: false,
          requestId: null,
          isDataOutdated: invalidated,
          error: invalidated ? null : error
        }
      }
    };
  },
  "onboarding/INVALIDATE_EMPLOYEE_UNAVAILABILITIES": (
    state,
    { enterpriseId, employeeId }
  ) => {
    if (!enterpriseId) return state;
    let changed = false;
    const entries = { ...state.employeeUnavailabilities };
    Object.keys(entries).forEach((key) => {
      const entry = entries[key];
      if (
        entry.enterpriseId !== enterpriseId ||
        (employeeId && entry.employeeId !== employeeId)
      )
        return;
      changed = true;
      entries[key] = {
        ...entry,
        isDataOutdated: true,
        invalidationVersion: entry.invalidationVersion + 1,
        error: null
      };
    });
    return changed ? { ...state, employeeUnavailabilities: entries } : state;
  },
  "onboarding/REMOVE_EMPLOYEE_UNAVAILABILITY": (state, { key, id }) => {
    const entry = state.employeeUnavailabilities[key];
    if (!entry) return state;
    return {
      ...state,
      employeeUnavailabilities: {
        ...state.employeeUnavailabilities,
        [key]: {
          ...entry,
          list: entry.list.filter((item) => item._id !== id),
          isDataOutdated: true,
          invalidationVersion: entry.invalidationVersion + 1,
          error: null
        }
      }
    };
  }
};
